// extracted by mini-css-extract-plugin
export default {"loader":"Loading_loader__237zN","rotation":"Loading_rotation__caYWZ"};